/**
 * FF AI Workspace Design System - 飞书风格主题
 * 
 * 统一的颜色和排版规范
 */

export const colors = {
  // 主色
  primary: '#3370ff',
  primaryHover: '#1e5eff',
  primaryActive: '#0e4fcb',
  
  // 文字
  textPrimary: '#1f2329',
  textSecondary: '#646a73',
  textTertiary: '#8f959e',
  textDisabled: '#bbbfc4',
  
  // 背景
  bgPrimary: '#ffffff',
  bgSecondary: '#f7f8fa',
  bgTertiary: '#eff0f1',
  bgHover: '#f7f8fa',
  
  // 边框
  border: '#e5e6eb',
  borderHover: '#c9cdd4',
  
  // 状态色
  success: '#00b42a',
  warning: '#ff7d00',
  error: '#f53f3f',
  info: '#3370ff',
  
  // 用户状态
  statusActive: '#00b42a',
  statusInactive: '#8f959e',
  statusSuspended: '#ff7d00',
  statusTerminated: '#f53f3f',
};

export const typography = {
  h1: 'text-2xl font-semibold text-[#1f2329]',
  h2: 'text-xl font-semibold text-[#1f2329]',
  h3: 'text-lg font-medium text-[#1f2329]',
  h4: 'text-base font-medium text-[#1f2329]',
  body: 'text-sm text-[#1f2329]',
  bodySecondary: 'text-sm text-[#646a73]',
  caption: 'text-xs text-[#8f959e]',
  link: 'text-sm text-[#3370ff] hover:text-[#1e5eff] cursor-pointer',
};

